import { Pipe, PipeTransform} from '@angular/core';
import _ from 'lodash';
import { Util } from '../utils/util';

@Pipe({name: 'findIn'})
export class FindInPipe implements PipeTransform {

	transform(list: any[], filterValue: string): any {
		
		return list.filter(item => {
			if (!filterValue) return true;

			let valuesStr = Util.getString(item);
			const filter = filterValue.toLocaleLowerCase().replace(/\s/gi, "");
			return valuesStr.indexOf(filter) >= 0;
		});
	}		
}


// WEBPACK FOOTER //
// ./src/app/pipes/find-in-pipe.ts